// *******************************************************
// Button - Get Started
// -------------------------------------------------------
// Get Stared Button on the home page
// -------------------------------------------

// *******************************************
// Module Imports
// -------------------------------------------
import React, { Component, Fragment } from 'react';
// --------------------------------

// *******************************************
// Style Imports
// -------------------------------------------
import { Fill, Stroke, MixBlend, Opacity } from '../../../../styles';
// --------------------------------

class Neutral extends Component {

    render() {
        const { width, height, xPos, yPos, active, onClick } = this.props;

        return (
            <svg xmlns="http://www.w3.org/2000/svg" x={xPos} y={yPos} width={width} height={height} viewBox="0 0 227 235">
            <title>
                ResultNeutralLarge
            </title>
            <g class="cls-1">
                <g id="Layer_2" data-name="Layer 2">
                    <g id="moosh">
                        <path class={[Fill.green].join(" ")} d="M0,122.07C0,59.27,41.25,0,113.46,0c77.07,0,114,59.27,114,122.07A113.71,113.71,0,1,1,0,122.07Z"/>
                        <path class={[Fill.offWhite].join(" ")} d="M179.09 91.51c-.06 14.15-9.51 23.5-23.66 23.4-13-.09-22.62-10.08-22.72-23.59-.1-13.76 9.57-15.79 23.19-15.73C170.19 75.64 179.15 77.05 179.09 91.51zM71.4 113.23C58.79 113.16 50.06 104 50.16 91c.1-12.62 8.67-19.17 19.63-18.91C84 72.45 93.52 79.2 93.32 91.52 93.11 104.3 84 113.3 71.4 113.23z"/>
                        <path class={[Fill.green].join(" ")} d="M76.85,88.66A10.51,10.51,0,0,0,60.52,98.5a11.37,11.37,0,0,0,7.27,9.39C79.68,112.21,87.37,95.57,76.85,88.66Z"/>
                        <path class={[Fill.lightBlack].join(" ")} d="M74.94,91.66a7,7,0,0,0-10.89,6.56,7.58,7.58,0,0,0,4.85,6.26C76.83,107.36,82,96.27,74.94,91.66Z"/>
                        <circle class={[Fill.white].join(" ")} cx="77.3" cy="92.9" r="4.6"/>
                        <path class={[Fill.green].join(" ")} d="M158,85.15A12,12,0,0,0,146.35,99.6c1,5.89,6.39,10.3,11.7,10.3C171.62,109.9,172.15,85.32,158,85.15Z"/>
                        <path class={[Fill.lightBlack].join(" ")} d="M157.79,89.21a8.09,8.09,0,0,0-7.85,9.71,8.41,8.41,0,0,0,7.86,6.92C166.92,105.84,167.27,89.32,157.79,89.21Z"/>
                        <circle class={[Fill.white].join(" ")} cx="164.2" cy="91.2" r="4.2"/>
                        <path class={[Fill.greenSix, Opacity._06].join(" ")} d="M212.28 116.16c.64 2.81-2.13 4.72-6.18 5.86-4.43 1.25-7.42-.13-8.5-4.63-1.15-4.79.15-9.11 5-10.74C208.93 104.54 210.11 109.89 212.28 116.16zM199.68 92.35c3.2 0 5.43 1 6.11 4s-1.31 4.26-3.87 4.9c-2.95.73-4.45-.63-5.23-3.36C195.8 94.84 198 93.71 199.68 92.35zM203.67 135.77c-2.48.46-5-.14-5.67-2.85a4.54 4.54 0 0 1 3.44-5.6c2.34-.59 4.27.45 4.94 3.11C207 132.93 206.39 134.75 203.67 135.77zM19.33 119.31c-.83 3.64 2.76 6.11 8 7.6 5.74 1.62 9.62-.17 11-6 1.49-6.21-.19-11.81-6.49-13.92C23.67 104.25 22.15 111.19 19.33 119.31zM35.66 88.46c-4.14 0-7 1.34-7.92 5.23s1.69 5.52 5 6.35c3.82 1 5.77-.82 6.78-4.35C40.69 91.68 37.88 90.22 35.66 88.46z"/>
                        <path class={[Fill.lightBlack].join(" ")} d="M176.36,174.33l.76-2.87a25.83,25.83,0,0,0-3.51-.8c-1.72-.21-3.22.55-4.86.53-2,0-4-.67-6-.71-9-.18-18.1,0-27.14,0H115.25A68.35,68.35,0,0,1,99,171.62c-3.17-.2-6.31-.73-9.46-1.14H70c-8,.49-15.94,1.09-23.93,1.22a3.76,3.76,0,0,0-.79,3,2.48,2.48,0,0,1,.62-.08c11.22,0,22.44.66,33.66.41,5-.11,9.88-.18,14.86.19s9.67.93,14.53,1a72.5,72.5,0,0,0,14.43-1.71,60.2,60.2,0,0,1,14.31-1.23,192.43,192.43,0,0,1,29.59,3.47c1.6.33,3.54.91,5.19.6,1.28-.24,2-1.35,3.05-2a7.26,7.26,0,0,1,.75-.4A2,2,0,0,1,176.36,174.33Z"/>
                        <path class={[Fill.lightBlack, Stroke.lightBlack, Stroke.Width_2, Opacity._03, MixBlend.multiply].join(" ")} d="M91.53 51.14a8.09 8.09 0 0 0-5-2.06c-1.48-.12-2.92-.58-4.4-.62a16.15 16.15 0 0 1-1.7 0 5.86 5.86 0 0 1-1.08-.27q-3.71.05-7.41.07c-8.74.38-17.48 1-26.2 1.72a3.52 3.52 0 0 0 3.36 4.57c7.24 0 14.47 0 21.71 0a29.82 29.82 0 0 1 4.61-.09c1.29.2 2.49.85 3.79 1.07s2.76.12 4.18.4c.79.16 1.59.18 2.39.26a2.7 2.7 0 0 0 .58 0l.23.07C90 59.19 95 54.2 91.53 51.14zM138.08 57.82h6.3c2.1-.27 4.19-.59 6.29-.89a107.19 107.19 0 0 1 14-.9c4.85-.06 9.71-.08 14.45 1.06.86.21 1.72.44 2.57.68a3.86 3.86 0 0 0 .28-5.58A67.59 67.59 0 0 0 171.16 51c-11.47-.5-23-.17-34.44-.13C133.5 52.13 133.95 57.82 138.08 57.82z"/>
                    </g>
                </g>
            </g>
        </svg>
    );
}
}

Neutral.defaultProps = {
    active: true,
    width: 227,
    height: 235,
    xPos: 0,
    yPos: 0
}

export default Neutral;



// WEBPACK FOOTER //
// ./src/components/Face/Neutral/Active/index.js